import { pushToDataLayer } from '../../pushToDataLayer';
import {
  GTMEvent,
  GTMEventAttributes,
  GTMEventName,
  GTMVideoAttributes,
} from '../../types';
import { mapToGTMVideoAttributes } from '../../utils';
import { GTMVideoInteractonEventArguments } from './types';

export function videoInteractonEvent({
  action,
  videoIds,
  videoAttributes,
  vehicleData,
}: GTMVideoInteractonEventArguments) {
  const eventAttributes: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.VIDEO_INTERACTION,
  };

  const gtmVideoAttributes: GTMVideoAttributes =
    mapToGTMVideoAttributes(videoAttributes);

  pushToDataLayer({
    ...eventAttributes,
    action,
    video_ids: videoIds,
    ...gtmVideoAttributes,
    ...vehicleData,
  });
}
